import { DangrousNotificationType } from '@bymason/controller-api-hooks';

export const commandDescription = {
  [DangrousNotificationType.Reboot]:
    'This action will reboot the device. The device will power down and restart.' +
    ' It will be offline until it finishes rebooting.',

  [DangrousNotificationType.Shutdown]:
    'This action will power off the device.' +
    ' The device will be offline until it is manually powered back on.',

  [DangrousNotificationType.Wipe]:
    'This action will trigger a reboot, clearing all local data on the device,' +
    ' and reset the device to the current Project configuration state.' +
    ' The device will be offline until it finishes rebooting.',

  [DangrousNotificationType.Refurbish]:
    'This action will perform a factory data reset on the device.' +
    ' All user data will be removed. The device will be unlinked from your Mason account.' +
    ' Please do not perform this action if you are unsure if you need to.',
};
